import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "../src/assets/css/style.scss";
import "../src/assets/css/admin-theme.scss";
import "../src/assets/css/admin-theme-v2.scss";
import "../src/assets/css/admin-theme-v3.scss";
import "../src/assets/css/admin-theme-v4.scss";
import "../src/assets/css/king999-premium.scss";
import "../src/assets/css/king999-final.scss";
import "../src/assets/css/king999-client-final.scss";
import "../src/assets/css/king999-unified-pages.scss";
import "../src/assets/css/king999-critical-fixes.scss";
import "../src/assets/css/king999-polish-v5.scss";
import "../src/assets/css/king999-mobile-heading-fix.scss";
import "../src/assets/css/king999-user-details-responsive.scss";
import "../src/assets/css/king999-professional-polish.scss";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

reportWebVitals();
